import * as AWS from "aws-sdk";

// MinIO Configuration (S3-compatible)
const minioConfig = {
  endpoint: process.env.REACT_APP_MINIO_ENDPOINT || "https://s3.blocsys.com",
  accessKeyId: process.env.REACT_APP_MINIO_ACCESS_KEY || "BlocsysS3admin",
  secretAccessKey: process.env.REACT_APP_MINIO_SECRET_KEY || "Blocsysadmin07",
  s3ForcePathStyle: true, // Required for MinIO
  signatureVersion: "v4",
  region: process.env.REACT_APP_MINIO_REGION || "us-east-1",
};

// Create S3 instance for MinIO
const s3 = new AWS.S3(minioConfig);

// Default bucket name
const BUCKET_NAME = process.env.REACT_APP_MINIO_BUCKET_NAME || "vestn";

export { s3, BUCKET_NAME };
export default s3;
